const eventTanyaTasia = () => {
  if (typeof window !== 'undefined') {
    (window as any)?.dataLayer?.push({
      event: `generalEvent`,
      eventName: `bottom_tanya_tasia_button`,
      eventCategory: `bottom navigation`,
      eventAction: `click on tanya tasia`,
    });
  }
};
export default eventTanyaTasia;
